
export enum Action {
  None,
  CloseAllTooltips,
  AddCustomer,
  AddUser,
  UpdateUser,
  UpdateMultipleUsers,
  UpdateCustomer,
  CustomersUpdated,
  UsersUpdated,
  SetPassword,
  RoleTemplatesUpdated,
  SystemTemplatesUpdated,
  AddSystemTemplate,
  UpdateSystemTemplate,
  ShowProfile,
  ShowAdminSettings,
  PickTokaraCustomer,
  TokaraCustomerPicked,
  GroupsUpdated,
  GroupCollectionsUpdated,
  SSORoleTemplatesUpdated,
  PickGroup,
  GroupPicked,
  AddGroup,
  UpdateGroup,
  PickUser,
  UserPicked,
  PickCustomer,
  CustomerPicked
}

export interface ActionParams {
  userId?: string;
  customerId?: number;
  templateId?: number;
  silent?: boolean;
  userIds?: Array<string>;
  customerIds?: Array<number>;
}
export interface ActionProvider {
  onAction(act: Action, params?: ActionParams): void;
}

export default class ActionMgr {
  private static _actions= new Map<Action, Array<ActionProvider>>();
  static registerAction (act: Action | Action[], provider: ActionProvider): void {
    if (Array.isArray(act)) {
      act.forEach((a) => {
        ActionMgr.registerAction(a, provider)
      })
    } else {
      if (!ActionMgr._actions.has(act)) ActionMgr._actions.set(act, [])
      const providers = ActionMgr._actions.get(act)
      if (providers !== undefined) {
        providers.push(provider)
      }
    }
  }

  static triggerAction (act: Action, params?: ActionParams): void {
    console.log('Action triggered', act, params)
    if (act !== Action.CloseAllTooltips && (!params || !params.silent)) {
      // Close all tooltips before bringing up any other actions, unless command is silent
      ActionMgr.triggerAction(Action.CloseAllTooltips)
    }
    const provider = ActionMgr._actions.get(act)
    if (provider !== undefined) {
      provider.forEach((p) => {
        p.onAction(act, params)
      })
    }
  }
}
